/**
 * TrendModa - Son Görüntülenen Ürünler (LocalStorage tabanlı)
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'tm_recently_viewed';
  var MAX_ITEMS = 8;

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getViewed() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveViewed(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function addCurrentProduct() {
    var meta = document.querySelector('[data-product-json]');
    if (!meta) return;

    var product;
    try {
      product = JSON.parse(meta.textContent);
    } catch (e) { return; }

    if (!product || !product.id) return;

    // featured_image: string (URL) ya da null
    var imgSrc = '';
    if (product.featured_image) {
      imgSrc = typeof product.featured_image === 'string'
        ? product.featured_image
        : (product.featured_image.src || product.featured_image.url || '');
    } else if (product.images && product.images[0]) {
      imgSrc = typeof product.images[0] === 'string' ? product.images[0] : (product.images[0].src || '');
    }

    var item = {
      id: product.id,
      title: product.title || '',
      url: product.url || ('/products/' + product.handle),
      price: product.price || 0,
      compare_at_price: product.compare_at_price || 0,
      image: imgSrc
    };

    var viewed = getViewed();
    viewed = viewed.filter(function (v) { return v.id !== item.id; });
    viewed.unshift(item);
    viewed = viewed.slice(0, MAX_ITEMS);
    saveViewed(viewed);
  }

  function buildImgSrc(raw) {
    if (!raw) return '';
    // Shopify CDN URL'ye width parametresi ekle
    var url = String(raw);
    // Zaten parametre varsa _300x formatına dönüştür, yoksa ekle
    if (url.indexOf('cdn.shopify.com') !== -1) {
      // Shopify image URL: ...jpg?v=xxx şeklinde gelebilir
      var sep = url.indexOf('?') !== -1 ? '&' : '?';
      return url + sep + 'width=300';
    }
    return url;
  }

  function renderRecentlyViewed() {
    var container = document.getElementById('recentlyViewed');
    var grid = document.getElementById('recentlyViewedGrid');
    if (!container || !grid) return;

    var currentId = parseInt(container.dataset.currentProduct || '0', 10);
    var viewed = getViewed().filter(function (v) { return v.id !== currentId; });

    if (!viewed.length) return;

    container.style.display = 'block';

    // HTML injection'dan kaçınmak için textContent ile DOM oluştur
    var fragment = document.createDocumentFragment();

    viewed.forEach(function (item) {
      var imgSrc = buildImgSrc(item.image);
      var price = item.price
        ? (item.price / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' TL'
        : '';

      var a = document.createElement('a');
      a.href = item.url; // Shopify ürün URL'si güvenli
      a.className = 'recently-viewed-card';

      if (imgSrc) {
        var img = document.createElement('img');
        img.src = imgSrc;
        img.alt = item.title;
        img.loading = 'lazy';
        a.appendChild(img);
      }

      var info = document.createElement('div');
      info.className = 'recently-viewed-card__info';

      var titleEl = document.createElement('p');
      titleEl.className = 'recently-viewed-card__title';
      titleEl.textContent = item.title; // textContent = XSS-safe

      var priceEl = document.createElement('p');
      priceEl.className = 'recently-viewed-card__price';
      priceEl.textContent = price;

      info.appendChild(titleEl);
      info.appendChild(priceEl);
      a.appendChild(info);
      fragment.appendChild(a);
    });

    grid.innerHTML = '';
    grid.appendChild(fragment);
  }

  function init() {
    addCurrentProduct();
    renderRecentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
